export var TenantTag;
(function (TenantTag) {
    /* Development tenants are free to use but are not meant to be used as production environment. */
    TenantTag["Development"] = "development";
    /* A production tenant must have an associated subscription plan, even if it's a free plan. */
    TenantTag["Production"] = "production";
})(TenantTag || (TenantTag = {}));
